import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiVisa } from '../../../models/base/apivisa.model';
import { PagingResponseModel } from '../../../models/base/paging-response.model';
import { CMSPostContainerModel } from '../../../models/cms/cms-post-container.model';
import { CMSPostSubjectContainerModel } from '../../../models/cms/cms-post-subject-container.model';
import { Pagination } from '../../../models/pagination/pagination.model';
import { Core2Config } from '../../../utils/core2-config';
import { getHttpHeader } from '../../../utils/http-header.factory';
import { QueryService } from '../../../templates/services/query-service.template';

@Injectable({
  providedIn: 'root'
})
export class CMSPostService extends QueryService<CMSPostContainerModel> {

  constructor(protected readonly h: HttpClient) {
    super(Core2Config.TENANT_DOMAIN_URL_PREFIX + 'cms/posts', h);
  }

  public queryWithSubject(p: Pagination, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<PagingResponseModel<CMSPostSubjectContainerModel>>{
    return this.http.get<PagingResponseModel<CMSPostSubjectContainerModel>>(`${ api_domain_url }${ this.apiUrl }/subject/query?${ p.toString() }`, getHttpHeader(jwt_secret, tenantCode));
  }
}
